
import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { Subscription } from 'rxjs';
import { NavItem } from 'src/app/interfaces/nav-item';
import { TabService } from 'src/app/services/tab.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { HTTPService } from 'src/app/services/http.service';
import { NavService } from 'src/app/services/nav.service';

@Component({
    selector: 'system-view-new-item',
    templateUrl: './system-view-new-item.component.html',
    styleUrls: ['./system-view-new-item.component.scss'],
    standalone: false
})
export class SystemViewNewItemComponent implements OnInit {
  
  useTab:boolean = false;
  
  @Input()items:NavItem[];
  

  constructor(public navService: NavService,
              public router: Router,
              public tabService:TabService,
              private UserAuthenticationServices:UserAuthenticationServices,
              ) {
  }

  ngOnInit() {
    
  }

  ngOnDestroy(){

  }

  onItemSelected(item: NavItem) {
    this.navService.selectItem2(item, this.router, this.tabService, item.route, this.UserAuthenticationServices.user.iduser);    
  }

}

